export const DOCS__PERMISSIONS = {
  KNOWLEDGE_BASE: {
    VIEW: {
      permissionGroupName: 'Przeglądanie kolekcji, modułów i artykułów w bazie wiedzy',
      DEFAULT_OR_ASSIGNED: {
        dbName: 'DOCS__KNOWLEDGE_BASE__VIEW__DEFAULT_OR_ASSIGNED',
        name: 'Domyślne',
        description:
          'Możliwość przeglądania wszystkich opublikowanych kolekcji (przypisanych za pomocą roli, bezpośrednio do użytkownika lub widocznych domyślenie dla wszystkich), modułów oraz opublikowanych wersji artykułów w nich zawartych'
      },
      ALL: {
        dbName: 'DOCS__KNOWLEDGE_BASE__VIEW__ALL',
        name: 'Wszystkie',
        description:
          'Możliwość przeglądania wszystkich kolekcji, modułów oraz opublikowanych wersji artykułów w nich zawartych '
      }
    },
    MANAGE: {
      permissionGroupName: 'Zarządzanie bazą wiedzy',
      NONE: {
        dbName: 'DOCS__KNOWLEDGE_BASE__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości zarządzania bazą wiedzy.'
      },
      ASSIGNED: {
        dbName: 'DOCS__KNOWLEDGE_BASE__MANAGE__ASSIGNED',
        name: 'Przypisane kolekcje',
        description: `Możliwość tworzenia/edycji/archiwizacji (publicznych i niepublicznych) artykułów w kolekcjach przypisanych za pomocą roli, lub bezpośrednio do użytkownika, 
        wyboru artykułów, które są widoczne tylko dla zalogowanych użytkowników,
        widok archiwum artykułów oraz wszystkich wersji artykułów`
      },
      ALL: {
        dbName: 'DOCS__KNOWLEDGE_BASE__MANAGE__ALL',
        name: 'Wszystkie kolekcje',
        description: `Możliwość tworzenia/edycji/archiwizacji artykułów (publicznych i niepublicznych) we wszystkich kolekcjach (włączając te, które nie zawierają żadnych opublikowanych artykułów) oraz wszystkich wersji artykułów, 
          wyboru artykułów, które są widoczne tylko dla zalogowanych użytkowników,
          widok archiwum artykułów oraz wszystkich wersji artykułów`
      }
    }
  },

  COLLECTION: {
    MANAGE: {
      permissionGroupName: 'Zarządzanie kolekcjami',
      NONE: {
        dbName: 'DOCS__COLLECTION__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości zarządzania kolekcjami'
      },
      ASSIGNED: {
        dbName: 'DOCS__COLLECTION__MANAGE__ASSIGNED',
        name: 'Możliwość zarządzania kolekcjami',
        description: `Możliwość tworzenia kolekcji i edytowania przypisanych kolekcji,
         możliwość zarządzania użytkownikami przypisanymi do kolekcji,
        (za pomocą roli lub bezpośrednio do użytkownika) kolekcji.`
      },
      ALL: {
        dbName: 'DOCS__COLLECTION__MANAGE__ALL',
        name: 'Wszystkie kolekcje',
        description: `Możliwość tworzenia, edytowania i publikowania wszystkich kolekcji, 
        możliwość zarządzania rolami i użytkownikami przypisanymi do kolekcji,
        dostęp do widoku admina dla bazy wiedzy`
      }
    }
  }
}
